// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  /* Шрифты */
  --font-primary: 'AR One Sans', sans-serif;
  --font-secondary: 'Inter', sans-serif;
  
  /* Веса шрифтов */
  --font-regular: 400;
  --font-medium: 500;
  --font-semibold: 600;
  --font-bold: 700;
  
  /* Размеры шрифтов */
  --font-size-xs: 12px;
  --font-size-sm: 14px;
  --font-size-md: 16px;
  --font-size-lg: 18px;
  --font-size-xl: 20px;
  --font-size-2xl: 24px;
  --font-size-3xl: 30px;
  --font-size-3xl: 32px;
  --font-size-4xl: 36px;
  
  /* Высота строки */
  --line-height-tight: 1.2;
  --line-height-normal: 1.5;
  --line-height-loose: 1.8;
  
  /* Цвета */
  --color-background: #1D1D1F;    /* Основной цвет страницы */
  --color-header: #35363C;        /* Цвет шапки */
  --color-text-primary: #FFFFFF;  /* Основной цвет текста на темном фоне */
  --color-text-secondary: #E0E0E0; /* Вторичный цвет текста */
  --color-accent: #229ed9;        /* Акцентный цвет (из иконки Telegram) */ /* Вторичный цвет текста */
  --color-accent-super-light: #72c5eb20;  
  --color-accent-super-light-pressed: #72c5eb6b;  
  --color-accent-pressed: #1B7FAD;  /* Цвет акцента при нажатии (темнее на 20%) */
  --color-accent-dark: #4A7EA6;
  --color-accent-light: #70AEDD;  /* Цвет акцента при нажатии (темнее на 20%) */
  --color-success: #25D366;       /* Цвет успеха (из иконки WhatsApp) */
  --color-border: #444444;        /* Цвет границ */
  --color-hover: #4A4B52;         /* Цвет при наведении */
  --color-primary: #DE5456;          /* Цвет ссылок */
  --color-base-gray: #D9D9D9;
  --color-base-gray-light: #D9D9D9;

  /* Радиусы */
  --border-radius-sm: 4px;
  --border-radius-md: 8px;
  --border-radius-lg: 16px;
}

/* 
* CSS переменные для шрифтов, цветов и их параметров
* Использование: 
* font-family: var(--font-primary);
* font-weight: var(--font-medium);
* color: var(--color-text-primary);
* background-color: var(--color-background);
*/ `, "",{"version":3,"sources":["webpack://./src/styles/variables.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,yCAAyC;EACzC,qCAAqC;;EAErC,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;;EAEhB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;;EAErB,kBAAkB;EAClB,wBAAwB;EACxB,yBAAyB;EACzB,wBAAwB;;EAExB,UAAU;EACV,2BAA2B,KAAK,2BAA2B;EAC3D,uBAAuB,SAAS,eAAe;EAC/C,6BAA6B,GAAG,wCAAwC;EACxE,+BAA+B,EAAE,0BAA0B;EAC3D,uBAAuB,SAAS,wCAAwC,EAAE,0BAA0B;EACpG,qCAAqC;EACrC,6CAA6C;EAC7C,+BAA+B,GAAG,6CAA6C;EAC/E,4BAA4B;EAC5B,6BAA6B,GAAG,6CAA6C;EAC7E,wBAAwB,QAAQ,qCAAqC;EACrE,uBAAuB,SAAS,gBAAgB;EAChD,sBAAsB,UAAU,uBAAuB;EACvD,wBAAwB,WAAW,gBAAgB;EACnD,0BAA0B;EAC1B,gCAAgC;;EAEhC,YAAY;EACZ,uBAAuB;EACvB,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;;;;;;;CAOC","sourcesContent":[":root {\n  /* Шрифты */\n  --font-primary: 'AR One Sans', sans-serif;\n  --font-secondary: 'Inter', sans-serif;\n  \n  /* Веса шрифтов */\n  --font-regular: 400;\n  --font-medium: 500;\n  --font-semibold: 600;\n  --font-bold: 700;\n  \n  /* Размеры шрифтов */\n  --font-size-xs: 12px;\n  --font-size-sm: 14px;\n  --font-size-md: 16px;\n  --font-size-lg: 18px;\n  --font-size-xl: 20px;\n  --font-size-2xl: 24px;\n  --font-size-3xl: 30px;\n  --font-size-3xl: 32px;\n  --font-size-4xl: 36px;\n  \n  /* Высота строки */\n  --line-height-tight: 1.2;\n  --line-height-normal: 1.5;\n  --line-height-loose: 1.8;\n  \n  /* Цвета */\n  --color-background: #1D1D1F;    /* Основной цвет страницы */\n  --color-header: #35363C;        /* Цвет шапки */\n  --color-text-primary: #FFFFFF;  /* Основной цвет текста на темном фоне */\n  --color-text-secondary: #E0E0E0; /* Вторичный цвет текста */\n  --color-accent: #229ed9;        /* Акцентный цвет (из иконки Telegram) */ /* Вторичный цвет текста */\n  --color-accent-super-light: #72c5eb20;  \n  --color-accent-super-light-pressed: #72c5eb6b;  \n  --color-accent-pressed: #1B7FAD;  /* Цвет акцента при нажатии (темнее на 20%) */\n  --color-accent-dark: #4A7EA6;\n  --color-accent-light: #70AEDD;  /* Цвет акцента при нажатии (темнее на 20%) */\n  --color-success: #25D366;       /* Цвет успеха (из иконки WhatsApp) */\n  --color-border: #444444;        /* Цвет границ */\n  --color-hover: #4A4B52;         /* Цвет при наведении */\n  --color-primary: #DE5456;          /* Цвет ссылок */\n  --color-base-gray: #D9D9D9;\n  --color-base-gray-light: #D9D9D9;\n\n  /* Радиусы */\n  --border-radius-sm: 4px;\n  --border-radius-md: 8px;\n  --border-radius-lg: 16px;\n}\n\n/* \n* CSS переменные для шрифтов, цветов и их параметров\n* Использование: \n* font-family: var(--font-primary);\n* font-weight: var(--font-medium);\n* color: var(--color-text-primary);\n* background-color: var(--color-background);\n*/ "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
